import React from 'react';
import videojs from 'video.js';

//import socketIOClient from 'socket.io-client';

import spanish_videojs from '../../config/videojs_lang';

import { language } from '../../locales/i18n';

// CSS for contextmenu plugin
import 'videojs-contextmenu-ui/dist/videojs-contextmenu-ui.css';

// Expose videojs globally for plugins
if (typeof window !== 'undefined') {
	window.videojs = videojs;
}

// Flag to track if plugins are loaded
let pluginsLoaded = false;

const loadPlugins = async () => {
	if (pluginsLoaded) return;
	try {
		await import('videojs-contextmenu-ui/dist/videojs-contextmenu-ui.min.js');
		await import('videojs-youtube/dist/Youtube.min.js');
		pluginsLoaded = true;
	} catch (e) {
		console.warn('Error loading videojs plugins:', e);
	}
};

//import serverConfig from '../../services/Server/config';

class Player extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}
	async componentDidMount() {
		// Load plugins dynamically after videojs is globally available
		await loadPlugins();

		const { contextUrl, context } = this.props;
		const self = this;
		const { eventId } = this.props;

		if (language === 'es') {
			spanish_videojs(videojs);
		}

		videojs.options.liveui = true;

		this.player = videojs(
			this.videoNode,
			this.props.videoJsProps,
			function onPlayerReady() {
				//this.hlsQualitySelector();
				this.contextmenuUI({
					content: [
						{
							href: contextUrl,
							label: context,
						},
					],
				});

				self.props.onLoad();

				/*var socket = socketIOClient(
					`${serverConfig.path}:${serverConfig.port}`
				);*/

				let browserId = localStorage.getItem('playerId');
				let isPlaying = false;

				if (browserId === null) {
					const d = new Date();
					browserId = `${d.getTime()}_${
						Math.floor(Math.random() * 99999) + 10000
					}`;
					localStorage.setItem('playerId', browserId);
				}

				const d = new Date();
				let socket_id = `${d.getTime()}_${
					Math.floor(Math.random() * 99999) + 10000
				}`;

				const send_data = (end_point, data) => {
					const url = `https://eventovirtual-co.appspot.com/${eventId}/${browserId}/${socket_id}/${end_point}`;
					fetch(url, {
						method: 'POST',
					});
				};

				const socket = {
					emit: send_data,
				};

				socket.emit('connection');

				const startPing = () => {
					if (isPlaying) {
						socket.emit('alive', {
							id: eventId,
							browserId,
						});
					}

					setTimeout(startPing, 60000);
				};

				setTimeout(startPing, 30000);

				let isFirtsPlay = true;

				this.on('play', (event) => {
					if (isFirtsPlay) {
						socket.emit('start', {
							id: eventId,
							browserId,
						});

						isFirtsPlay = false;
					}
					isPlaying = true;
					socket.emit('play', {
						id: eventId,
						browserId,
					});
				});

				this.on('pause', (event) => {
					isPlaying = false;
					socket.emit('pause', {
						id: eventId,
						browserId,
					});
				});
			}
		);

		/*this.player.brand({
			image: image,
			title: title,
			destination: destination,
			destinationTarget: '_blank',
		});*/
	}
	componentWillUnmount() {
		if (this.player) {
			this.player.dispose();
		}
	}
	render() {
		return (
			<React.Fragment>
				<div>
					<div data-vjs-player>
						<video
							id="current_player"
							style={this.props.style}
							ref={(node) => (this.videoNode = node)}
							controls
							preload="auto"
							playsInline
							className="video-js vjs-default-skin vjs-16-9 vjs-big-play-centered"
						></video>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Player;
